import { useEffect, useState } from "react"
import { useUser } from "../../../../lib/user"
import { useHideFailedRenewalModal } from "./useHideFailedRenewalModal"
import type { GracePeriodEntitlement } from "../../../../types"
import { getGracePeriodEntitlement } from "../GracePeriodEntitlement/api"
import { usePathname } from "next/navigation"

const PAGE_EXCLUSIONS = [
  "/legal/terms-and-conditions",
  "/us/legal/terms-and-conditions",
]

export function useFailedRenewalModal() {
  const { isLoggedIn, isMember } = useUser()
  const [loading, setLoading] = useState<boolean>(true)
  const [entitlement, setEntitlement] =
    useState<GracePeriodEntitlement | null>()
  const { isHidden, hideModal } = useHideFailedRenewalModal()
  const pathName = usePathname()

  useEffect(() => {
    if (PAGE_EXCLUSIONS.includes(pathName)) {
      setLoading(true)
      return
    }

    if (!isLoggedIn || isMember) {
      setLoading(false)
      return
    }

    if (isHidden) {
      setLoading(false)
      return
    }

    getGracePeriodEntitlement().then((gracePeriodEntitlement) => {
      setEntitlement(gracePeriodEntitlement)
      setLoading(false)
      if (gracePeriodEntitlement === null) {
        hideModal("NO_ENTITLEMENT")
      }
    })
  }, [isLoggedIn, isMember, isHidden, hideModal, pathName])

  return {
    loading,
    entitlement,
  }
}
